import $http from '$http'
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';

export default {
    methods: {

        // GET /api/NewAgent/GetById
        GetById(Id) {
            var Params = {
                Sid: this.sysSid,
                Session: this.sysSession,
                Id: Id
            };

            $http.get('api/NewAgent/GetById', Params).then(res => {
                let {
                    Data
                } = res.data;
                util.doResult(this, res, () => {
                    this.form = Data
                    this.baseInfo = cloneDeep(this.form.Customer);
                    this.contact = cloneDeep(this.form.Contact);
                    this.Companys = this.form.Companys
                    //this.agentList = this.form.List


                });
            });
        },

    }
};


// WEBPACK FOOTER //
// ./src/pages/CRMAgentManage/CRMFormatAgent/components/viewDialog/services.js